import React, { useState } from "react";
import { Tabs } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import CpWiseManifest from "./CpWiseManifest";
import ConsolidatedManifest from "./ConsolidatedList";
import McnShipmentList from "./McnShipmentList";
import "./style.scss";
import Heading from "../../../components/Heading";
import sorting from "../../../assests/images/SVG/sort-white.svg";

const items = [
  {
    key: "1",
    label: "Consolidated Shipment List",
    children: <ConsolidatedManifest />,
  },
  {
    key: "2",
    label: "CP Wise Shipment List",
    children: <CpWiseManifest />,
  },
  {
    key: "3",
    label: "MCN Shipment List",
    children: <McnShipmentList />,
  },
];

const index = () => {
  const location = useLocation();
  const navigate = useNavigate();
  
  // Get the active tab from URL query parameter or default to "1"
  const [activeTab, setActiveTab] = useState(() => {
    const urlParams = new URLSearchParams(location.search);
    const tabFromUrl = urlParams.get("tab");
    
    if (tabFromUrl && ["1", "2", "3"].includes(tabFromUrl)) {
      return tabFromUrl;
    }
    
    return "1";
  });

  // Handle tab change
  const handleTabChange = (key) => {
    setActiveTab(key);
    
    // Update URL query parameter
    const urlParams = new URLSearchParams(location.search);
    urlParams.set("tab", key);
    navigate(`${location.pathname}?${urlParams.toString()}`, { replace: true });
  };

  return (
    <div className="p2 consolidated-tab-cntr">
      <Heading
        title={"In Scan"}
        nextPage={"/sort-shipment"}
        nextPageTitle={"Sort Shipment"}
        imgSrc={sorting}
      />
      <Tabs 
        activeKey={activeTab} 
        onChange={handleTabChange}
        items={items} 
      />
    </div>
  );
};

export default index;
